import { h, Component } from 'preact'
import { Router } from 'preact-router'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'

import Header from './header'
import Footer from './footer'
import Home from '../routes/home'
import FillSupport from '../routes/fillsupport'
import Create from '../routes/create'
import CreateGroup from '../routes/create-group'
import NotFound from '../routes/notfound'
import Success from '../routes/success'
import Politician from '../routes/politician/politician'
import Login from '../routes/login'

import Spinner from './atoms/spinner'

// import Home from 'async!./home';
// import Profile from 'async!./profile';

const Tooltip = styled(ReactTooltip)`
  max-width: 800px;
  ol {
    font-size: 16px;
  }
`

const Content = styled.div`
  padding: 130px 0 130px 0;
  min-height: 100%;
  margin-left: calc(100vw - 100%);
`

const FullScreen = styled.div`
  min-height: 100%;
  position: relative;
`

function extractQuery(url) {
  try {
    const ret = {}
    url
      .split('?')[1]
      .split('&')
      .map(a => a.split('='))
      .forEach(v => {
        ret[v[0]] = decodeURIComponent(v[1])
      })
    return ret
  } catch (e) {
    return {}
  }
}
/* global document */
export default class App extends Component {
  state = {
    polyfilled: false,
    query:
      typeof document !== 'undefined'
        ? extractQuery(`${document.location.href}`)
        : {},
    url: '/',
  }

  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
  handleRoute = e => {
    /* global dataLayer */
    if (typeof dataLayer !== 'undefined') {
      console.log(e.url, 'dataLayer.push({ event: "page" })')
      dataLayer.push({ event: 'page' })
    }
    this.setState({
      url: e.url,
      query: extractQuery(e.url),
    })
  }

  render() {
    if (typeof Symbol === 'undefined' && !this.state.polyfilled) {
      import('../polyfills').then(() => this.setState({ polyfilled: true }))
      console.log('loading polyfills')
      return <Spinner />
    }
    return (
      <FullScreen>
        <Header url={this.state.url} />
        <Content>
          <Router onChange={this.handleRoute}>
            <Home path="/" query={this.state.query} />
            <Home path="/vsichni" all query={this.state.query} />
            <FillSupport path="/vyplnit-podporu/:page?" />
            <Create path="/pridat-politika" />
            <CreateGroup path="/pridat-skupinu" />
            <Success path="/uspech" />
            <Politician path="/hlas/:page" />
            <Login path="/login" />
            <NotFound default />
          </Router>
        </Content>
        <Footer />
        <Tooltip html />
      </FullScreen>
    )
  }
}



// WEBPACK FOOTER //
// ./components/app.js